
import { cacheService } from '@/lib/cacheService';
import { invalidateAllDealerCaches } from '@/hooks/recommended-dealers/cache';

/**
 * Invalidate all dealer-related caches
 */
export const invalidateDealerCaches = (): void => {
  try {
    invalidateAllDealerCaches();
    console.log('All dealer-related caches invalidated');
  } catch (error) {
    console.error('Error invalidating dealer caches:', error);
  }
};

/**
 * Invalidate all caches for a specific dealer
 */
export const invalidateDealerCacheById = (dealerId: string): void => {
  try {
    if (typeof cacheService.deletePattern === 'function') {
      cacheService.deletePattern(new RegExp(`dealer-${dealerId}`));
    } else {
      // Manual fallback
      cacheService.delete(`dealer-${dealerId}`);
      cacheService.delete(`dealer-ratings-${dealerId}`);
      cacheService.delete(`dealer-quotations-${dealerId}`);
    }
    console.log(`Cache invalidated for dealer ${dealerId}`);
  } catch (error) {
    console.error(`Error invalidating cache for dealer ${dealerId}:`, error);
  }
};

/**
 * Invalidate all application caches (use with caution)
 */
export const invalidateAllCaches = (): void => {
  try {
    cacheService.clear();
    console.log('All application caches cleared');
  } catch (error) {
    console.error('Error clearing all caches:', error);
  }
};
